export default __webpack_public_path__ + "static/media/astro_hands_on_hips.59767d7e.png";